import React from 'react';
import { Twitter, Facebook, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom'; // <-- Import Link
import './Footer.css';
import logo from "../Assets/logowhite.webp";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img
              src={logo}
              alt="Boldly English logo"
              width={440}
              height={147}
              loading="lazy"
              decoding="async"
            />
          </div>
          
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Hi</Link></li>
              <li><Link to="/beginners">Let's Start</Link></li>
              <li><Link to="/about">Know Us</Link></li>
              <li><Link to="/levelup">Test Your English</Link></li>
            </ul>
          </div>
          
          <div className="footer-links">
            <h3>Our Course</h3>
            <ul>
              <li><Link to="/beginners">Beginner</Link></li>
              <li><Link to="/intermediate">Intermediate</Link></li>
              <li><Link to="/advanced">Advanced</Link></li>
            </ul>
          </div>
          
          <div className="footer-newsletter">
            <h3>Our Location</h3>
            <p>Thoothukudi: 21, Mani Nagar 3rd Street, Thoothukudi 628003</p>
            <p>Chennai: 2nd Floor, Maruthi Complex, 152, 100 Feet Rd, Kamala Nehru Nagar, Vinayakapuram, Arumbakkam, Chennai, Tamil Nadu 600106</p>
            
            <div className="social-links">
              <a href="https://twitter.com/#/" target="_blank" rel="noopener noreferrer">
                <Twitter size={18} />
              </a>
              <a href="#rwet" onClick={(e) => e.preventDefault()}>
                <Facebook size={18} />
              </a>
              <a href="#er" onClick={(e) => e.preventDefault()}>
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} BOLDLY ENGLISH. All rights reserved.</p>
          <p>Designed with <span className="heart">❤</span> for BOLDLY ENGLISH</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
